import React from 'react';

import './nav.scss';

const Nav = () => {
  return (
    <nav className="nav">
      <ul className="nav__list">
        <li className="nav__item">
          <a className="nav__link" href="https://hands.ru/company/about/">
            О сервисе
          </a>
        </li>
        <li className="nav__item nav__item_city">Москва</li>
      </ul>
    </nav>
  );
};

export default Nav;
